<template>
  <div class="modal fade" id="cite-modal" tabindex="-1" role="dialog"  aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="color-line"></div>
        <div class="modal-header ">
          <div class="row text-left">
            <div class="col-xs-10"><h4 class="modal-title">Cite</h4></div>
            <div class="col-xs-2 text-right">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </div>
        <div class="modal-body">

          <div class="row m-b-md">
            <span class="m-b"><b>ISO 690 :</b> </span><br>

            <template v-for="(coAuthor, key) in document.co_authors"><template v-if="key > 0">, </template>{{coAuthor.lastName.toUpperCase()}}, {{coAuthor.firstName}}<template v-if="key === (document.co_authors.length - 1) ">. </template></template>

            <span v-if="document.title" v-html="document.title.replace(/<(?:.|\n)*?>/gm, '')"> </span>,
            <i v-if="document.publication" v-html="document.publication"></i>, ({{ new Date(document.pubDate).getFullYear()}}).

          </div>
          <div class="row  m-b-md">
            <span class="m-b"><b>APA :</b> </span><br>

            <template v-for="(coAuthor, key) in document.co_authors">
              <template v-if="key > 0">, <template v-if="key === (document.co_authors.length - 1) ">& </template></template>
              {{coAuthor.lastName}},{{coAuthor.firstName.slice(0,1)}}.
              
            </template>
            ({{ new Date(document.pubDate).getFullYear()}}).
            <span v-if="document.title" v-html="document.title.replace(/<(?:.|\n)*?>/gm, '')"> </span>.
            <i v-if="document.publication" v-html="document.publication"></i>.

          </div>
          <div class="row">
            <span class="m-b"><b>MLA :</b> </span><br>

            <template v-for="(coAuthor, key) in document.co_authors">
              <template v-if="key > 0">, and </template>
              {{coAuthor.lastName}} {{coAuthor.firstName}}
              <template v-if="key === (document.co_authors.length - 1) ">. </template>
            </template>
            <span v-if="document.title" v-html="document.title.replace(/<(?:.|\n)*?>/gm, '')"> </span>.
            <template ><i v-if="document.publication" v-html="document.publication"></i>, ({{ new Date(document.pubDate).getFullYear()}}).</template>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: ['value', 'document'],
  name: 'CiteModal',
  watch: {
  },
  methods: {
  },
  data () {
    return {
    }
  },
  mounted () {
    $('#cite-modal').modal()
    $('#cite-modal').on('hidden.bs.modal', (e) => {
      this.$emit('input', false)
    })
  },
  beforeMount () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/CiteModal.vue